import { ErrorMessage } from '@occc-app/lib/ErrorMessage';

/* Action Types */

const MARKETING_CONTENT_COMPONENT_ERR = 'hq/Offer/Constraints/MARKETING_CONTENT_COMPONENT_ERR';
const MARKETING_CONTENT_COMPONENT_OK = 'hq/Offer/Constraints/MARKETING_CONTENT_COMPONENT_OK';
const MARKETING_CONTENT_UPDATE = 'hq/Offer/MarketingContent/MARKETING_CONTENT_UPDATE';
const REQUEST_MARKETING_CONTENT = 'hq/Offer/MarketingContent/REQUEST_MARKETING_CONTENT';
const REQUEST_MARKETING_CONTENT_ERR = 'hq/Offer/MarketingContent/REQUEST_MARKETING_CONTENT_ERR';
const REQUEST_MARKETING_CONTENT_OK = 'hq/Offer/MarketingContent/REQUEST_MARKETING_CONTENT_OK';
const REQUEST_MARKETING_CONTENTS_OK = 'hq/Offer/MarketingContent/REQUEST_MARKETING_CONTENTS_OK';
const RESET_INITIAL_MARKETING_CONTENT_STATE =
  'hq/Offer/MarketingContent/RESET_INITIAL_MARKETING_CONTENT_STATE';

type Types = {
  MARKETING_CONTENT_COMPONENT_ERR: typeof MARKETING_CONTENT_COMPONENT_ERR;
  MARKETING_CONTENT_COMPONENT_OK: typeof MARKETING_CONTENT_COMPONENT_OK;
  MARKETING_CONTENT_UPDATE: typeof MARKETING_CONTENT_UPDATE;
  REQUEST_MARKETING_CONTENT: typeof REQUEST_MARKETING_CONTENT;
  REQUEST_MARKETING_CONTENT_ERR: typeof REQUEST_MARKETING_CONTENT_ERR;
  REQUEST_MARKETING_CONTENT_OK: typeof REQUEST_MARKETING_CONTENT_OK;
  REQUEST_MARKETING_CONTENTS_OK: typeof REQUEST_MARKETING_CONTENTS_OK;
  RESET_INITIAL_MARKETING_CONTENT_STATE: typeof RESET_INITIAL_MARKETING_CONTENT_STATE;
};

const types: Types = {
  MARKETING_CONTENT_COMPONENT_ERR,
  MARKETING_CONTENT_COMPONENT_OK,
  MARKETING_CONTENT_UPDATE,
  REQUEST_MARKETING_CONTENT,
  REQUEST_MARKETING_CONTENT_ERR,
  REQUEST_MARKETING_CONTENT_OK,
  REQUEST_MARKETING_CONTENTS_OK,
  RESET_INITIAL_MARKETING_CONTENT_STATE,
};

// Marketing Content
export type MarketingContent = {
  locale: string;
  title: string;
  imageUrl: string;
  shortDescription: string;
  longDescription: string;
  terms: string;
  termsUrl: string;
  disclaimer: string;
  disclaimerUrl: string;
};

type MarketingContentComponentERR = (
  errorMessages: ErrorMessage[],
  error: Error,
) => {
  type: typeof MARKETING_CONTENT_COMPONENT_ERR;
  errorMessages: ErrorMessage[];
  error: Error;
};

type MarketingContentComponentOK = (id: string) => {
  type: typeof MARKETING_CONTENT_COMPONENT_OK;
  id: string;
};

type MarketingContentUpdate = (
  key: string,
  value: any,
) => {
  type: typeof MARKETING_CONTENT_UPDATE;
  key: string;
  value: any;
};

type RequestMarketingContent = (id: string) => {
  type: typeof REQUEST_MARKETING_CONTENT;
  id: string;
};

type RequestMarketingContentERR = (
  errorMessages: ErrorMessage[],
  error: Error,
) => {
  type: typeof REQUEST_MARKETING_CONTENT_ERR;
  errorMessages: ErrorMessage[];
  error: Error;
};

type RequestMarketingContentOK = (marketingContent: MarketingContent) => {
  type: typeof REQUEST_MARKETING_CONTENT_OK;
  marketingContent: MarketingContent;
};

type RequestMarketingContentsOK = () => {
  type: typeof REQUEST_MARKETING_CONTENTS_OK;
};

type ResetInitialMarketingContentState = (marketingContent: MarketingContent) => {
  type: typeof RESET_INITIAL_MARKETING_CONTENT_STATE;
  marketingContent: MarketingContent;
};

export type Action =
  | ReturnType<MarketingContentComponentERR>
  | ReturnType<MarketingContentComponentOK>
  | ReturnType<MarketingContentUpdate>
  | ReturnType<RequestMarketingContent>
  | ReturnType<RequestMarketingContentERR>
  | ReturnType<RequestMarketingContentOK>
  | ReturnType<RequestMarketingContentsOK>
  | ReturnType<ResetInitialMarketingContentState>;

export type ActionCreators = {
  MarketingContentComponentERR: MarketingContentComponentERR;
  MarketingContentComponentOK: MarketingContentComponentOK;
  MarketingContentUpdate: MarketingContentUpdate;
  RequestMarketingContent: RequestMarketingContent;
  RequestMarketingContentERR: RequestMarketingContentERR;
  RequestMarketingContentOK: RequestMarketingContentOK;
  RequestMarketingContentsOK: RequestMarketingContentsOK;
  ResetInitialMarketingContentState: ResetInitialMarketingContentState;
};

/* State Types */

type OfferComponentMetaData = {
  error: Error | null;
  errorMessages: ErrorMessage[];
  id: string;
  dirty: boolean;
  requesting: boolean;
  submitting: boolean;
};

export type State = OfferComponentMetaData & MarketingContent;
export default types;
